import {SxProps, Theme} from "@mui/material";

export const GameOuterBoxStyle: SxProps<Theme> = {
	marginTop: 2,
	width: "80%", height: "70%",
	display: "flex", flexDirection: "column",
	justifyContent: "center", alignItems: "center"
}